import { render, staticRenderFns } from "./TheLink.vue?vue&type=template&id=00e2de3c&scoped=true"
import script from "./TheLink.vue?vue&type=script&lang=js"
export * from "./TheLink.vue?vue&type=script&lang=js"
import style0 from "./TheLink.vue?vue&type=style&index=0&id=00e2de3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e2de3c",
  null
  
)

export default component.exports